import { Overflow, OverflowItem, Tab, TabList } from "@fluentui/react-components";
import { useAtom } from "jotai";
import { devices } from "library/constants";
import { ECompanyContentTab } from "library/types";
import { useTranslation } from "react-i18next";
import { employerContentTabAtom } from "store/UIEmployerPage";
import styled from "styled-components";

import { OverflowMenuComponent } from "components/OverflowMenuComponent/OverflowMenuComponent";

const tabs = [
  {
    id: ECompanyContentTab.details,
    name: "hbh.employerDetails.label",
    // icon: <GiftOpenRegular />,
    disabled: true,
  },
  {
    id: ECompanyContentTab.documents,
    name: "hbh.employerDocuments.label",
    // icon: <GiftOpenRegular />,
    disabled: false,
  },
];

export function SelectContent() {
  const { t } = useTranslation();
  const [selectedContentTab, setSelectedContentTab] = useAtom(employerContentTabAtom);

  const onTabSelect = (tab) => {
    setSelectedContentTab(tab);
  };

  return (
    <div>
      <Overflow minimumVisible={2}>
        <StyledTabList
          selectedValue={selectedContentTab}
          onTabSelect={(_, d) => onTabSelect(d.value as ECompanyContentTab)}
        >
          {tabs.map((tab) => {
            return (
              <OverflowItem
                key={tab.id}
                id={tab.id}
                priority={tab.id === selectedContentTab ? 2 : 1}
              >
                <StyledTab disabled={tab.disabled} value={tab.id}>
                  {t(tab.name)}
                </StyledTab>
              </OverflowItem>
            );
          })}
          <OverflowMenuComponent tabs={tabs} onTabSelect={onTabSelect} />
        </StyledTabList>
      </Overflow>
    </div>
  );
}

const StyledTabList = styled(TabList)`
  border-bottom: 1px solid ${({ theme }) => theme.palette.neutralLight};
  @media only screen and ${devices.md} {
    gap: 20px;
  }
`;
const StyledTab = styled(Tab)`
  @media only screen and ${devices.md} {
    padding: 10px 25px;
  }
`;
